import React, { useState } from 'react'
import FollowingTabs from '../../components/hometabs/FollowingTabs';
import SuggestedTabs from '../../components/hometabs/SuggestedTabs';
import '../home/Home.css'


const Home = () => {
  const [activeTab, setActiveTab] = useState(0); // Tracks the active tab


  return (
      <div className='dashboard-content-box'>
        <div className='schedule-modal-tabs'>
            <div className="tabs-container">
                <div className="tabs-header d-flex flex-wrap justify-content-center align-content-center">
                <button  className={`tab-button d-flex align-items-center ${activeTab === 0 ? "active" : ""}`} onClick={() =>  setActiveTab(0)}>
                  <span className='icons-btn'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.16006 10.87C9.06006 10.86 8.94006 10.86 8.83006 10.87C6.45006 10.79 4.56006 8.84 4.56006 6.44C4.56006 3.99 6.54006 2 9.00006 2C11.4501 2 13.4401 3.99 13.4401 6.44C13.4301 8.84 11.5401 10.79 9.16006 10.87Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.41 4C18.35 4 19.91 5.57 19.91 7.5C19.91 9.39 18.41 10.93 16.54 11C16.46 10.99 16.37 10.99 16.28 11" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.15997 14.56C1.73997 16.18 1.73997 18.82 4.15997 20.43C6.90997 22.27 11.42 22.27 14.17 20.43C16.59 18.81 16.59 16.17 14.17 14.56C11.43 12.73 6.91997 12.73 4.15997 14.56Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.3401 20C19.0601 19.85 19.7401 19.56 20.3001 19.13C21.8601 17.96 21.8601 16.03 20.3001 14.86C19.7501 14.44 19.0801 14.16 18.3701 14" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  </span>
                  <span className='text-btn'>Following</span>
                </button>
                <button   className={`tab-button  d-flex align-items-center ${activeTab === 1 ? "active" : ""}`} onClick={() =>  setActiveTab(1)}>
                  <span className='icons-btn'>
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.92306 8.69231C10.0472 8.69231 11.7692 6.97032 11.7692 4.84615C11.7692 2.72198 10.0472 1 7.92306 1C5.79889 1 4.0769 2.72198 4.0769 4.84615C4.0769 6.97032 5.79889 8.69231 7.92306 8.69231Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.2308 19.4615H1V18.6275C1.01225 17.4549 1.3215 16.3045 1.89888 15.2838C2.47626 14.2631 3.30292 13.4054 4.30165 12.7908C5.30038 12.1762 6.4386 11.8247 7.60997 11.7693C8.78135 11.7138 9.94768 11.9562 11 12.4737" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.3845 11.7692V21" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.7693 16.3846H21.0001" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  </span>
                  <span className='text-btn'>Suggested</span>
                </button>
                </div>

                {/* Tab Content */}
                <div className="tabs-content">
                {activeTab === 0 && (
                    <div className="tab-panel">
                        <FollowingTabs />
                    </div>
                )}
                {activeTab === 1 && (
                    <div className="tab-panel">
                        <SuggestedTabs />
                    </div>
                )}
                </div>
            </div>
        </div>

      </div>
  )
}

export default Home
